/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import s from './Navigation.css';
import { Link } from 'react-router-dom'
import { userTypes} from "../../UserTypes";

class Navigation extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

    render() {
    let userType = sessionStorage.getItem('userType')
    let root = require('Config').root;
    return (
      <div className={s.root} role="navigation">
        <Link className={s.link} to="/message"><i className={s.message} />{this.props.locale.message}</Link>
        <Link className={s.link} to="/contacts"><i className={s.contacts} />{this.props.locale.contacts}</Link>
        <Link className={s.link} to="/sent"><i className={s.send} />{this.props.locale.sent}</Link>
          {userType == userTypes.Fyrirtaeki ?
        <Link className={s.link} to="/templates"><i className={s.templates} />{this.props.locale.templates}</Link>
          : ''}
        <Link className={s.link} to="/groups"><i className={s.group} />{this.props.locale.groups}</Link>
        <Link className={s.link} to="/api"><i className={s.api} />{this.props.locale.api}</Link>
      </div>
    );
  }
}

export default (Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js